import {
    queryOptions,
    useQuery,
  } from '@tanstack/react-query';
  
  import { baseAPI } from '~shared/api/base-api';
  import { QUERY_KEYS } from '~shared/api/query-keys';
  
export interface AuditFilterOption {
  value: string;
  label: string;
}

  export const getAuditResourcesAPI = async () => {
    const response = await baseAPI.get<Array<AuditFilterOption>>(
      `audit-logs/resources`,
    );
    return response.data;
  };
  
  export const getAuditResourcesOptions = () => {
    return queryOptions({
      queryKey: QUERY_KEYS.AUDIT_RESOURCES(),
      queryFn: () => getAuditResourcesAPI(),
    });
  };
  
  export const useGetAuditResources = () => {
    return useQuery(getAuditResourcesOptions());
  };
  